module.exports = __webpack_public_path__ + "static/img/white-ball.e742ff9.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/NikeWebGL/Pages/Play/img/start/white-ball.png
// module id = 194
// module chunks = 0